import * as utils from "_metronic/utils/utils";

const localStorageLastLocationKey = "last-location";

const MAX_LOCATIONS = 20;

function acceptLocation(lastLocation) {
  const routesToIgnore = [
    /^\/$/, // just "/"
    /^\/auth/, // "/auth" routes
    /^\/provider/, // "/provider" routes
    /^\/logout/, // "/logout" route
  ];

  if (!lastLocation?.pathname) {
    return false;
  }

  const shouldIgnore = routesToIgnore.some((route) => route.test(lastLocation.pathname));

  return !shouldIgnore;
}

export function saveLastLocation(lastLocation) {
  const localStorageLocations = utils.getStorage(localStorageLastLocationKey);
  let _useLocations = localStorageLocations ? JSON.parse(localStorageLocations) : [];

  if (acceptLocation(lastLocation)) {
    _useLocations.push(`${lastLocation.pathname}${lastLocation.search}`);

    // store only last 20 locations
    _useLocations = _useLocations.slice(-MAX_LOCATIONS);

    utils.setStorage(localStorageLastLocationKey, JSON.stringify(_useLocations), 120);
  }
}

export function forgotLastLocation() {
  utils.removeStorage(localStorageLastLocationKey);
}

export function getLastLocation() {
  const localStorageLocations = utils.getStorage(localStorageLastLocationKey);
  if (!localStorageLocations) {
    return "/";
  }

  const _userLocations = JSON.parse(localStorageLocations);
  const result = _userLocations.length > 0 ? _userLocations.pop() : "/";
  return result;
}
